import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { PaymentProviderStatusDto } from '@/features/dashboard/paymentProviders/types/PaymentProviderStatusDto.ts';
import { TpaySetupRequest } from '@/features/dashboard/paymentProviders/types/TpaySetupRequest.ts';

const paymentProvidersApi = {
  getStatus: async (): Promise<PaymentProviderStatusDto[]> => {
    return await fetchPrivateApi<PaymentProviderStatusDto[]>(
      'GET',
      'settings/payment-providers/status',
    );
  },

  setupTpay: async (dto: TpaySetupRequest): Promise<void> => {
    return await fetchPrivateApi<void>(
      'POST',
      'settings/payment-providers/tpay',
      dto,
    );
  },

  deleteTpay: async (): Promise<void> => {
    return await fetchPrivateApi<void>(
      'DELETE',
      'settings/payment-providers/tpay',
    );
  },

  registerTpay: async (email: string): Promise<{ activationLink: string }> => {
    return await fetchPrivateApi<{ activationLink: string }>(
      'POST',
      'settings/payment-providers/tpay/register',
      { email },
    );
  },
};

export default paymentProvidersApi;
